import { usePermissionStore } from '@/stores/permission'

export default function vIfAndPermission(permissionValue:string, _ifValeu?:any) {
  // 获取用户所有的权限按钮
  const permissionStore = usePermissionStore()
  const permissionBtn = permissionStore.permission
  if (_ifValeu !== undefined) {
    // 同时满足v-if和权限设置
    if (permissionBtn.includes(permissionValue) && _ifValeu) {
      return true
    } else {
      return false
    }
  } else {
    if (permissionBtn.includes(permissionValue)) {
      return true
    } else {
      return false
    }
  }
}
